import { Box } from "@mui/material";
import DetailsCard from "../../molecules/Login/DetailsCard";

const BusinessDetails = ({
  businessDataDetails,
  setBusinessDataDetails,
}: {
  businessDataDetails: any;
  setBusinessDataDetails: any;
}) => {
  return (
    <Box display={"flex"} gap={"12px"}>
      <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
        <DetailsCard
          heading="Website"
          subHeading="Provide the official url of your business website"
          firstInputPlaceholder="https://www.example.com"
          firstInputId="website"
          firstInputLabel="Website"
          value={businessDataDetails.Website}
          firstInputOnChange={(e) =>
            setBusinessDataDetails({
              ...businessDataDetails,
              Website: e.target.value,
            })
          }
        />
        <DetailsCard
          heading="Business Name"
          subHeading="Provide the official name of your business"
          firstInputPlaceholder="Enter your business name"
          firstInputId="businessName"
          firstInputLabel="Business Name"
          value={businessDataDetails.Name}
          firstInputOnChange={(e) => {
            setBusinessDataDetails({
              ...businessDataDetails,
              Name: e.target.value,
            });
          }}
        />
        <DetailsCard
          heading="Primary Location"
          subHeading="Provide the primary location from which your business operates"
          firstInputPlaceholder="Enter your business name"
          firstInputId="name"
          firstInputLabel="Name"
          value={businessDataDetails.PrimaryLocation?.Location}
          firstInputOnChange={(e: any) => {
            setBusinessDataDetails({
              ...businessDataDetails,
              PrimaryLocation: {
                ...businessDataDetails.PrimaryLocation,
                Location: e.target.value,
              },
            });
          }}
          secondInputPlaceholder="Enter your business address"
          secondInputId="address"
          secondInputLabel="Address"
          secondInputOnChange={(e: any) => {
            setBusinessDataDetails({
              ...businessDataDetails,
              PrimaryLocation: {
                ...businessDataDetails.PrimaryLocation,
                Country: e.target.value,
              },
            });
          }}
        />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <DetailsCard
          heading="Where do you primarily serve your customers"
          subHeading="Indicate if you serve your customers at a physical location or online"
          isRadioButtons={true}
          value={businessDataDetails.BusinessObjective}
          radioGroupLabel="serverCustomersGroupLabel"
          radioGroupName="serverCustomersGroupName"
          firstInputOnChange={(e) =>
            setBusinessDataDetails({
              ...businessDataDetails,
              BusinessObjective: e.target.value,
            })
          }
          formControlLabelList={[
            { value: "local", label: "Local" },
            { value: "online", label: "Online" },
          ]}
        />

        <DetailsCard
          heading="What do you offer your customers?"
          subHeading="Indicate whether your business primarily serves its customers at a physical location or online"
          isRadioButtons={true}
          value={businessDataDetails.LocationType}
          radioGroupLabel="offerCustomersGroupLabel"
          radioGroupName="offerCustomersGroupName"
          firstInputOnChange={(e) =>
            setBusinessDataDetails({
              ...businessDataDetails,
              LocationType: e.target.value,
            })
          }
          formControlLabelList={[
            { value: "products", label: "Products" },
            { value: "services", label: "Services" },
            { value: "both", label: "Both" },
          ]}
        />
      </Box>
    </Box>
  );
};

export default BusinessDetails;
